import { Injectable } from '@angular/core';
import { Product } from '@models';
import { FundOverviewService } from '@products/services/fund-overview.service';
import { FundId, ShareClassCode } from '@types';
import { Logger } from '@utils/logger';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import etfTrackingQuery from '../graphql/etf-tracking-basket.graphql';

@Injectable({
  providedIn: 'root',
})
export class ETFTrackingBasketService {
  private etfTrackingFunds: Array<{
    fundId: string;
    shareClassCode: string;
  }> = [];
  constructor(private overviewService: FundOverviewService) {}

  public populate(
    fundId: FundId,
    shareClassCode: ShareClassCode
  ): Observable<any> {
    return this.overviewService
      .register(etfTrackingQuery, {
        fundId,
        shareClassCode,
      })
      .pipe(
        map((product: Product) => {
          if (product && product?.shareClasses.length) {
            return {
              effectiveDate: product.shareClasses[0]?.nav?.effectiveDate,
              overlap: product.shareClasses[0]?.nav?.overlap,
              fundId: product.shareClasses[0]?.identifiers?.fundId,
            };
          }
        })
      );
  }

  /**
   *
   * @param shareClassCode it is provide by product layout component
   * @param fundId the fund id  and shareclasscode is added in to array of etf trackign basket funds
   */
  public setEtfTrackingFunds(shareClassCode: string, fundId: string): void {
    this.etfTrackingFunds.push({
      fundId,
      shareClassCode,
    });
  }

  /**
   *
   * @param fundId the fund id for which corresponding shareclasscode is returned
   * @returns shareclasscode
   */
  public getShareClassCode(fundId: string): string {
    return this.etfTrackingFunds.filter((fund) => fund.fundId === fundId)[0]
      ?.shareClassCode;
  }
}
